import { render, staticRenderFns } from "./formCustomChoose.vue?vue&type=template&id=5c718141&"
import script from "./formCustomChoose.vue?vue&type=script&lang=js&"
export * from "./formCustomChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports